import { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

interface OfferFormSectionProps {
  number: number;
  title: string;
  children: ReactNode;
}

export default function OfferFormSection({ number, title, children }: OfferFormSectionProps) {
  return (
    <Box component="section" aria-labelledby={`offer-section-${number}`} sx={{ mb: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: 2 }}>
        <Box component="span" aria-hidden="true" sx={{ width: 30, height: 30, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, borderRadius: '50%', bgcolor: 'primary.light', color: 'primary.main', fontWeight: 700 }}>{number}</Box>
        <Typography id={`offer-section-${number}`} component="h3" variant="subtitle1">{title}</Typography>
      </Box>
      {children}
    </Box>
  );
}
